import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.overpaymentsPage.alertTitle, 'Alert'),
  cancel: () => __(translations.overpaymentsPage.cancel, 'Cancel'),
  yesImSure: () => __(translations.overpaymentsPage.yesImSure, "Yes, I'm sure"),
  toggleStatusMessage: () => __(translations.overpaymentsPage.toggleStatusMessage, 'Are you sure you want to change the status of this overpayment?'),
};
